<div *ngIf="researchStatus === 'ACTIVE' && researchUrl"  class="footer-container ">
  <div class="block-item align-center ">
    <a  (click)="researchRedirect()">
      <div class="research">
        <i class="fas fa-clipboard-list"></i>
        <div class="research-text">
          <span><b>Responder à pesquisa</b></span>
          <span>{{estimatedTimeResearch}}</span>
        </div>
      </div>
    </a>
  </div>
</div>
<div class="container print-visible">
  <div class="row col-md-5 m-auto print-visible">
    <div *ngIf="!image" class="row print-visible">
      <div class="col-6 d-flex print-visible">
        <img class="img-fluid float-start" src="assets/images/footer_branco.png" alt="">
      </div>
      <div class="col-6 d-flex print-visible">
        <img class="img-fluid" src="assets/images/poweredBy_branco.svg" alt="">
      </div>
    </div>
    <div class="col-12 d-flex print-visible justify-content-center">
      <img *ngIf="image" class="footer_img" [src]="image" alt="">
    </div>
    <div class="col-md-12 d-flex justify-content-center">
      <div class="policy-container">
        <a class="policy-link" target="blank" href="assets/docs/privacy-policy.html">Política de Privacidade</a>
      </div>
    </div>
  </div>
</div>
